import { getCurrentWeight, getWeightImage, getCurrentWeights, getResult } from './sessions.service';

let session = JSON.parse(localStorage.getItem('session'));

if (!session) {
  location.href = 'index.html';
}

$(() => {
  let currentWeight = getCurrentWeight(session);
  let countOfDisabled = 0;

  let weights = getCurrentWeights(session);

  console.log('Текущая сессия', session);
  console.log('Текущие веса', weights);
  console.log('Последний вес', currentWeight);

  let smilesToAnimate = [];

  for (let key in session) {
    $(`#${key}`).click(() => {
      if (session[key].answered) {
        location.href = `people.html#${key}`;
      } else {
        location.href = `task-page.html#${key}`
      }
    });

    if (session[key].answered) {
      $(`#${key}`).addClass('blocked');

      $(`#${key} .emoji`).css({
        'background-image': `url(./src/img/${getWeightImage(weights[key])})`,
      }).click((event) => {
        event.preventDefault();
        event.stopPropagation();
        location.href = 'people.html#' + key;
      });

      smilesToAnimate.push(key);

      countOfDisabled++;
    }
  }

  setInterval(() => {
    let rnd = Math.floor(Math.random() * smilesToAnimate.length);

    $(`#${smilesToAnimate[rnd]} .emoji`).css({
      'animation': `3s ease-in-out infinite emo-animation`,
      'animation-iteration-count': `1`,
    })

    setTimeout(() => {
      $(`#${smilesToAnimate[rnd]} .emoji`).css({
        'animation': ``,
        'animation-iteration-count': ``,
      })
    }, 2000)
  }, 3000)

  if (countOfDisabled < Object.keys(session).length) {
    $(`#resultLink`).addClass('disabled');
  }

  $('#resultLink').click(() => {
    let result = getResult(session);

    location.href = `r${result.weight}.html`;
  });
});




